import { defineMessage } from 'services/localization';

export const messages = {
    payWithAirwallex: defineMessage('pay_with_airwallex'),
    twoFaIsNotEnabled: defineMessage('fa_is_not_enabled'),
    disconnectedAirwallex: defineMessage('the_organisation_is_disconnected_from_airwallex'),
    disconnectedXero: defineMessage('the_organisation_is_disconnected_from_xero'),
    payNow: defineMessage('pay_now'),
    schedulePayment: defineMessage('schedule_payment'),
    alreadyScheduled: defineMessage('the_payment_is_already_scheduled'),
};
